import { IStore } from '../../index'

export function isSearchLoading(state: IStore): boolean {
  return state.search.isLoading || state.events.request.events.isFallbackLoading
}

export function isSearchReady(state: IStore): boolean {
  return (
    !state.search.isLoading &&
    !state.events.request.events.isFallbackLoading &&
    state.search.isReady
  )
}
